import React from 'react';

const DEFAULT_HEIGHTS_PCT = [38, 62, 44, 78, 52, 88, 36, 70, 48, 58, 82, 40, 66, 50, 74, 46, 68, 42, 76, 54];

/** Decorative waveform bars (not real audio analysis). */
export const UGCMusicWaveform: React.FC<{
  className?: string;
  barClassName?: string;
  /** Number of bars (repeats pattern). */
  bars?: number;
}> = ({ className = '', barClassName = 'bg-current', bars = 32 }) => {
  const pattern = Array.from({ length: bars }, (_, i) => DEFAULT_HEIGHTS_PCT[i % DEFAULT_HEIGHTS_PCT.length]);
  return (
    <div
      className={`flex h-full min-h-[28px] max-h-10 items-end justify-stretch gap-[2px] ${className}`}
      aria-hidden
    >
      {pattern.map((h, i) => (
        <div
          key={i}
          className={`min-w-[2px] flex-1 rounded-full opacity-80 ${barClassName}`}
          style={{ height: `${h}%`, maxHeight: '100%' }}
        />
      ))}
    </div>
  );
};

export default UGCMusicWaveform;
